module.exports = __webpack_public_path__ + "static/media/Inventor Tolerance Analysis.44172f86.png";